module.exports = __webpack_public_path__ + "img/postcard-blank.ed31dbac.jpg";